import { Sun, Moon, Monitor, Check } from "@phosphor-icons/react";
import { Button } from "./ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { useTheme } from "../contexts/ThemeContext";

const OPTIONS = [
  { key: "light", label: "Light", Icon: Sun },
  { key: "dark", label: "Dark", Icon: Moon },
  { key: "system", label: "Match my device", Icon: Monitor },
];

/* Sidebar / mobile-drawer theme picker: Light · Dark · Match my device. `theme` is what's on screen, `preference` is the saved choice. */
export default function ThemeMenu({ collapsed = false, className = "", testid = "theme-toggle", onPicked }) {
  const { theme, preference, setTheme } = useTheme();
  const current = OPTIONS.find((o) => o.key === preference) || OPTIONS[1];
  const CurrentIcon = current.Icon;
  const label = preference === "system" ? `Device (${theme})` : `${current.label} Mode`;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className={`w-full justify-start gap-3 text-muted-foreground ${className}`} data-testid={testid} title={`Theme: ${label}`}>
          <CurrentIcon size={18} />
          {!collapsed && <span className="text-xs">{label}</span>}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent side="top" align="start" className="w-52" data-testid={`${testid}-menu`}>
        <DropdownMenuLabel className="text-[11px] uppercase tracking-wide text-muted-foreground">Appearance</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {OPTIONS.map(({ key, label: l, Icon }) => (
          <DropdownMenuItem key={key} onSelect={() => { setTheme(key); onPicked?.(); }} className="gap-2 text-xs" data-testid={`${testid}-${key}`}>
            <Icon size={16} />
            <span className="flex-1">{l}</span>
            {preference === key && <Check size={14} weight="bold" className="text-primary" data-testid={`${testid}-${key}-selected`} />}
          </DropdownMenuItem>
        ))}
        {preference === "system" && <p className="px-2 pb-1.5 pt-1 text-[10px] text-muted-foreground">Following your device — currently {theme}.</p>}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
